<mat-form-field class="full-width-field">
    <mat-label>Lesson Type</mat-label>
    <mat-select
        ngModel
        name="lesson_type">
        <mat-option>None</mat-option>
        <mat-option *ngFor="let lesson of lesson_types"
            [value]="lesson.id">{{ lesson.value }}</mat-option>
    </mat-select>
</mat-form-field>